import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import * as moment from 'moment';
import { LocalStorageNativeService } from '../NativeLocalStorage.service';
import {
  AvailableLanguageKeys,
  SELECTED_LANGUAGE_LS_KEY,
} from './languagesData';
export const translateLoaderFactory = (theHttpClient: HttpClient) =>
  new TranslateHttpLoader(theHttpClient, 'assets/i18n/', '.json');

@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [],
  exports: [
    // ...MULTILANG_COMPONENTS,
    TranslateModule,
  ],
})
export class MultilingualModule {
  appLanguage: string;

  constructor(
    private translateService: TranslateService,
    private storageService: LocalStorageNativeService
  ) {
    this.setLanguage();
  }

  private async setLanguage() {
    this.translateService.addLangs([...Object.keys(AvailableLanguageKeys)]);
    this.translateService.setDefaultLang('en');

    this.appLanguage = this.translateService.getBrowserLang();

    const selectedLanguageKey = await this.storageService.getItem(
      SELECTED_LANGUAGE_LS_KEY
    );

    this.translateService
      .use(selectedLanguageKey || this.appLanguage)
      .subscribe(
        (x) => {
          moment.locale(selectedLanguageKey || this.appLanguage);
        },
        (error) => {
          moment.locale(this.translateService.getDefaultLang());
        }
      );
  }
}
